
import axios from "axios";
import { AppMessage } from "components";
import { store } from "store";
import { configUpdate } from "store/config";
import { OutputBaseProps } from "utils/types/API";
import { ConfigItemProps, ServicePriceProps } from ".";
import { aboutUpdate } from "store/about";
import { missionVisionUpdate } from "store/mision-vision";
import { servicePriceUpdate } from "store/service-price";

type ApiConfigOutputProps = OutputBaseProps<{ item: ConfigItemProps }, ConfigItemProps>

export const apiUpdateConfig = async (data: ConfigItemProps) => {
    const res = (await axios.put<ApiConfigOutputProps>("/api/config", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(configUpdate(res.data.item));
    }
    if (res.code === 0) {
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};


type ApiAboutOutputProps = OutputBaseProps<{ item: { title: string; content: string } }, ConfigItemProps>

export const apiUpdateAbout = async (data: ConfigItemProps) => {
    const res = (await axios.put<ApiAboutOutputProps>("/api/about", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(aboutUpdate(res.data.item));
    }
    if (res.code === 0) {
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};

type ApiMissionVisionOutputProps = OutputBaseProps<{ item: { thumbnailUrl?: string; title: string; subTitle?: string; content: string } }, ConfigItemProps>
export const apiUpdateMissionVision = async (data: ConfigItemProps) => {
    const res = (await axios.put<ApiMissionVisionOutputProps>("/api/mission-vision", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(missionVisionUpdate(res.data.item));
    }
    if (res.code === 0) {
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};


type ApiServicePriceOutputProps = OutputBaseProps<{
    item: ServicePriceProps
}>
export const apiUpdateServicePrice = async (data: ServicePriceProps) => {
    const res = (await axios.put<ApiServicePriceOutputProps>("/api/service-price", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(servicePriceUpdate(res.data.item));
    }
    if (res.code === 0) {
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};
